
import { ContentPostDownloadDto, PostDownloadDto, QuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditCategoryLikeMultiple from '../Editors/EditCategoryLikeMultiple';
import EditNumberWithSlider from '../Editors/EditNumberWithSlider';
import EditTwoDates from '../Editors/EditTwoDates';

interface GenPropQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}


const GenPropQuestion = (p: GenPropQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <EditPartContainer icon="globe" title="general properties" {...epc} registerClosed={registerClosed}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "clock", content: "published in between" }, editor: <EditTwoDates<PostDownloadDto> firstGetter={x => x.publicationDate} secondGetter={x => x.expirationDate} /> },
                        { label: { icon: "tag", content: "categories" }, editor: <EditCategoryLikeMultiple<ContentPostDownloadDto> getter={x => x.categories} toSelect="categories" /> },
                        { label: { icon: "smiley neutral", content: "points" }, editor: <EditNumberWithSlider<QuestionDownloadDto> getter={x => x.points} min={0} max={10} /> },
                        { label: { icon: "clock", content: "time" }, editor: <EditNumberWithSlider<QuestionDownloadDto> getter={x => x.time} min={0} max={120} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
        </>
    );
}
export default GenPropQuestion;